<template>
  <div class="native-table-wrap news-table">
    <table class="native-table">
      <thead>
        <tr>
          <th>序号</th><th>封面</th><th>标题</th><th>分类</th><th>摘要</th>
          <th>发布日期</th><th>状态</th><th>浏览量</th><th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in newsList" :key="row.id">
          <td>{{ index + 1 }}</td>
          <td><img v-if="row.image" class="cover-image" :src="row.image" :alt="row.title" /></td>
          <td class="truncate" :title="row.title">{{ row.title }}</td>
          <td>{{ row.category }}</td>
          <td class="truncate" :title="row.excerpt">{{ row.excerpt }}</td>
          <td>{{ row.date }}</td>
          <td><span class="status-tag" :class="`status-${row.status}`">{{ getStatusText(row.status) }}</span></td>
          <td>{{ row.views }}</td>
          <td class="actions">
            <NativeButton type="primary" size="small" @click="emit('edit', row)">编辑</NativeButton>
            <NativeButton type="danger" size="small" @click="emit('delete', row)">删除</NativeButton>
          </td>
        </tr>
        <tr v-if="newsList.length === 0"><td colspan="9" class="empty-cell">暂无数据</td></tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts" setup>
import type { NewsType } from "@/stores/news";

defineProps<{ newsList: NewsType[] }>();
const emit = defineEmits<{
  (event: "edit", row: NewsType): void;
  (event: "delete", row: NewsType): void;
}>();

const getStatusText = (status: number) =>
  status === 0 ? "已下架" : status === 1 ? "已发布" : "未知";
</script>

<style scoped>
.native-table-wrap { min-width: 0; overflow: auto; }
.native-table { width: 100%; border-collapse: collapse; font-size: 0.9rem; }
th, td { padding: 10px 12px; border: 1px solid #e2e8f0; text-align: left; vertical-align: middle; }
th { position: sticky; top: 0; background: #f8fafc; color: #334155; white-space: nowrap; }
tbody tr:nth-child(even) { background: #fafafa; }
.truncate { max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.cover-image { width: 38px; height: 38px; border-radius: 4px; object-fit: cover; }
.status-tag { display: inline-block; padding: 3px 8px; border-radius: 999px; background: #f1f5f9; }
.status-0 { background: #fff4db; color: #956000; }
.status-1 { background: #e8f7ee; color: #237447; }
.actions { display: flex; gap: 6px; }
.empty-cell { padding: 30px; color: #64748b; text-align: center; }
</style>
